import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  breakpoints,
  colors: { ui },
} = constants;
const { BreakpointNames } = breakpoints;
const { heading2Obj, heading5Obj } = typographyStyles;

const greyLight = ui.neutral[500];
const lightBlue = ui.core[100];

const errorPanelContainer = {
  marginTop: "50px",
  border: `2px solid ${lightBlue}`,
  padding: "30px",
  [mediaQuery.upTo(BreakpointNames.xs)]: {
    width: "100%",
    margin: "2em 3% 0 3%",
  },
};

const messageHeaderStyle = heading2Obj;

const messageBodyStyle = [
  heading5Obj,
  {
    color: greyLight,
  },
];

const textWrapperStyle = {
  width: "100%",
  paddingBottom: "10px",
};

const ctaWrapperStyle = {
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "25px",
};

const ctaStyle = [
  heading5Obj,
  {
    fontWeight: "unset",
    textDecoration: "none",
    marginLeft: "25px",
    padding: 0,
    color: lightBlue,
    ":hover, :focus": {
      textDecoration: "underline",
      color: lightBlue,
    },
  },
];

export {
  errorPanelContainer,
  messageBodyStyle,
  messageHeaderStyle,
  textWrapperStyle,
  ctaWrapperStyle,
  ctaStyle,
};
